export const tr = {
    at: 'Teklifi düzeltme oranı:',
    'at-percent': '%{conversionInput}',
    down: 'azalt',
    max: 'maks.',
    min: 'min.',
    up: 'artır'
};
